import useSWR from 'swr';
import { getFeatureFlagClient } from '../utils/featureFlag';
export const useFeatureFlag = () => {
    const { data, isLoading } = useSWR('FEATURE_FLAG_CLIENT', getFeatureFlagClient, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
    return { variation: data === null || data === void 0 ? void 0 : data.variation, isLoading };
};
//# sourceMappingURL=useFeatureFlag.js.map